import { render, staticRenderFns } from "./TCsSparkContent.vue?vue&type=template&id=5e0f7065&scoped=true"
import script from "./TCsSparkContent.vue?vue&type=script&lang=js"
export * from "./TCsSparkContent.vue?vue&type=script&lang=js"
import style0 from "./TCsSparkContent.vue?vue&type=style&index=0&id=5e0f7065&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0f7065",
  null
  
)

export default component.exports